export default {
    closed: "Live Class Closed",
    do_you_confirm_your_registration_for_the_live_class: "Do you confirm your registration for the {title} live class?",
    do_you_confirm_your_unsubscription_to_the_live_class: "Do you confirm your unsubscription to the {title} live class?",
    live_class_closed: "Live Class Closed",
    live_class_offline: "Live class offline",
    live_class_opened: "Live Class Open",
    live: "Live",
    loading_live_classes: "Loading live classes",
    next: "Next",
    no_live_classes_are_available_at_the_moment: "There are currently no live classes available",
    no_live_classes_are_available_with_the_selected_filter: "There are no live classes available for the selected filter",
    no_vacancy: "No vacancy",
    opened: "Live Class Open",
    please_wait_the_class_will_start_automatically: "Please wait. You will join the room soon.",
    receive_emails_about_this_live_class: "Receive emails about this live class",
    register_for_the_live_class: "Register for the live class",
    subscribe: "Subscribe",
    subscribed: "Subscribed",
    successfully_signed_up_for_the_live_class: "Successfully signed up for the live class",
    this_class_has_ended: "This class has ended",
    transmission_date: "Transmission Date",
    transmission_finished: "Transmission Finished",
    unsubscribe_from_the_live_class: "Unsubscribe from the live class",
    unsubscribe_successfully_for_the_live_class: "Unsubscribe successfully for the live class",
    unsubscribe: "Unsubscribe",
    your_live_class_will_start_soon_please_wait: "Your live class will start soon, please wait",
    this_reaction_assessment_will_only_be_unlocked_after_completing_all_activities_in_this_module: "This reaction assessment will only be unlocked after completing all activities in this module.",
    this_activity_will_only_be_unlocked_after_the_live_class_instructors_authorization: "This activity will only be unlocked after the live class instructor's authorization."
}